/**
 * "Leave without saving?" — the article editor's in-app confirmation when the
 * person goes Back with unsaved changes (LB6T2-REV-06).
 *
 * It replaced the editor's last native `window.confirm`, which headless
 * Playwright and assistive technology cannot see (the codebase removed the
 * same shape for that reason, #677 / #679). Same AlertDialog pattern as the
 * Library's delete, unpublish and classified-handling confirmations (L6-18).
 */
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export function LeaveUnsavedDialog({
  open, onStay, onLeave,
}: {
  open: boolean;
  /** Close the dialog and keep editing. */
  onStay: () => void;
  /** Leave the editor, dropping the unsaved changes. */
  onLeave: () => void;
}) {
  return (
    <AlertDialog open={open} onOpenChange={(next) => { if (!next) onStay(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Leave without saving?</AlertDialogTitle>
          <AlertDialogDescription>
            You have unsaved changes. They will be lost if you leave now.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep editing</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-leave-unsaved" onClick={onLeave}>
            Leave
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
